const state = () => ({
  list: [],
  current: null,
})

const getters = {
  list: (state) => state.list,
  current: (state) => state.current,
}

const mutations = {
  receiveList(state, list) {
    state.list = list
  },
  receiveCurrent(state, measurement) {
    state.current = measurement
  },
}

const actions = {
  getList({ commit, rootState }, patientId) {
    return this.$axios
      .post('/bodygram-backend/v1/app/digital-measurements/list', {
        accessToken: rootState.user.token,
        patientId,
        limit: -1,
      })
      .then((response) => {
        commit('receiveList', response.data.digitalMeasurements || [])
      })
  },
  get({ commit, rootState }, id) {
    return this.$axios
      .post('/bodygram-backend/v1/app/digital-measurements/get', {
        accessToken: rootState.user.token,
        id,
      })
      .then((response) => {
        commit('receiveCurrent', response.data.digitalMeasurement)
      })
  },
  delete({ rootState }, id) {
    return this.$axios.post(
      '/bodygram-backend/v1/app/digital-measurements/delete',
      {
        accessToken: rootState.user.token,
        id,
      }
    )
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
}
